// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1V5x-","title":"styles__title___1Ab_2","description":"styles__description___3a1kr","link":"styles__link___3H1Er"};